"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUploadFile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../DmsAltBox/DmsAltBox");
var _DmsSpinner = require("../DmsSpinner/DmsSpinner");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsTableButton = require("../DmsTableButton/DmsTableButton");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _reactDropzone = require("react-dropzone");
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _material = require("@mui/material");
var _CloudUpload = _interopRequireDefault(require("@mui/icons-material/CloudUpload"));
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * @Author: Jean Mira
 * @Date:   2024-09-09 17:46:39
 * @Last Modified by:   Jean Mira
 * @Last Modified time: 2024-09-11 16:45:50
 */

/*
 * Description: This component allows the user to upload a file
 *
 * Disclaimer: Uploading a file means to send the file to the
 * server. Importing a file means to get the content from this
 * uploaded file and saving it into the database.
 *
 * Props:
 *  - table_url: API that returns the uploaded files to be shown
 *  in the DmsTable component (this component already renders
 *  the DmsTable for you)
 *  - upload_url: API that will receive the file
 *  - import_url: API used to import the uploaded spreadsheet
 *  - download_url: API to download the uploaded files (defaults
 *  to /file/download)
 *  - callback: callback method to be called after the
 *  uploaded spreadsheet gets imported
*/
const DmsUploadFile = _ref => {
  let {
    table_url,
    upload_url,
    import_url,
    download_url
  } = _ref;
  const token = (0, _DmsTokenHook.getToken)();
  const table = (0, _react.useRef)(null);
  const [showSpinner, setShowSpinner] = (0, _react.useState)(false);
  const onDrop = (0, _react.useCallback)(async acceptedFiles => {
    setShowSpinner(true);
    const res = await (0, _DmsFetch.fetchUrl)(upload_url, "POST", token, acceptedFiles[0], false, true, null, null, "multipart/form-data");
    if (res.status === _HttpStatus.HTTP_STATUS.CREATED_201) {
      setShowSpinner(false);
      if (table.current) {
        table.current.updateTable();
      }
    }
  }, []);
  const submitImport = async function (e, data) {
    let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const res = await (0, _DmsFetch.fetchUrl)(import_url, "POST", token, {
      pk: data.pk
    }, false, true);
    if (callback && typeof callback === 'function' && res.status == _HttpStatus.HTTP_STATUS.OK_200) {
      callback();
    }
  };
  const submitDownload = async (e, data) => {
    (0, _DmsFetch.downloadUrl)(download_url + "?pk=" + data.pk, token);
  };
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = (0, _reactDropzone.useDropzone)({
    onDrop
  });
  const header = [{
    label: _reactIntlUniversal.default.get("OriginalFileName").d("Original File Name"),
    column_name: "original_filename"
  }, {
    label: _reactIntlUniversal.default.get("SavedFileName").d("Saved File Name"),
    column_name: "saved_filename"
  }, {
    label: _reactIntlUniversal.default.get("CreatedOn").d("Created On"),
    column_name: "created_on"
  }, {
    label: _reactIntlUniversal.default.get("Import").d("Import"),
    column_name: "import",
    width: "20px",
    element: /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, import_url && /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      icon: /*#__PURE__*/_react.default.createElement(_CloudUpload.default, null),
      onClick: submitImport,
      title: _reactIntlUniversal.default.get("Tooltip.Action.Import").d("Import")
    }), /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      icon: /*#__PURE__*/_react.default.createElement(_Download.default, null),
      onClick: submitDownload,
      title: _reactIntlUniversal.default.get("Tooltip.Action.Download").d("Download")
    }))
  }];
  return /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("UploadFiles").d("Upload Files"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement("div", getRootProps({
    className: "dropzone"
  }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), !showSpinner ? /*#__PURE__*/_react.default.createElement(_material.Typography, null, _reactIntlUniversal.default.get("Dragndropfileshereorclicktoselectfiles").d("Drag n' drop files here, or click to select files")) : /*#__PURE__*/_react.default.createElement(_DmsSpinner.DmsSpinner, null)))))), /*#__PURE__*/_react.default.createElement(_Row.default, null, /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Files").d("Files"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: table_url,
    header: header,
    needs_authentication: true,
    managed: true,
    export_table: false
  }))))));
};
exports.DmsUploadFile = DmsUploadFile;